








import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app'

@Component({
  components: {
  }
})
export default class Footer extends Vue {
   
}
